<template>
  <div class="common-layout">
    <el-container>
      <el-header class="head">
        <div class="head-right">
          <span class="username">{{ displayName }}</span>
          <el-button size="small" @click="pwdVisible = true">修改密码</el-button>
          <el-button size="small" type="danger" plain @click="logout">退出</el-button>
          <img src="@/assets/logo.png" alt />
        </div>
      </el-header>
      <el-container>
        <el-aside>
          <el-menu
            active-text-color="#ffd04b"
            background-color="#545c64"
            class="el-menu-vertical-demo menu"
            text-color="#fff"
            :default-active="currentRoute"
            router
          >
           <!-- default-active="/homeconfig/banner" -->
            <el-menu-item index="/home">
              <span>主页总览</span>
            </el-menu-item>
            <el-sub-menu index="1">
              <template #title>商品库</template>
              <el-menu-item index="/productmodule/productLibrary">商品库</el-menu-item>
              <el-menu-item index="/productmodule/classificationLibrary">分类库</el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="2">
              <template #title>首页配置</template>
              <el-menu-item index="/homeconfig/banner">banner</el-menu-item>
              <el-menu-item index="/homeconfig/jingangDistrict">金刚区</el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="3">
              <template #title>订单管理</template>
              <el-menu-item index="/order/orderList">订单列表</el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="6">
              <template #title>交易保障</template>
              <el-menu-item index="/guarantee/complaints">投诉列表</el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="4">
              <template #title>审核中心(可选)</template>
              <el-menu-item index="/auditing/audiList">审核列表(历史)</el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="5">
              <template #title>用户管理</template>
              <el-menu-item index="/userlist/userManagement">用户管理</el-menu-item>
            </el-sub-menu>
          </el-menu>
        </el-aside>
        <el-container>
          <el-main>
            <router-view />
          </el-main>
        </el-container>
      </el-container>
    </el-container>

    <el-dialog v-model="pwdVisible" title="修改登录密码" width="420px" :close-on-click-modal="false">
      <el-form :model="pwdForm" label-width="100px">
        <el-form-item label="旧密码" required>
          <el-input v-model="pwdForm.oldPassword" type="password" show-password />
        </el-form-item>
        <el-form-item label="新密码" required>
          <el-input v-model="pwdForm.newPassword" type="password" show-password placeholder="至少8位，勿用弱口令" />
        </el-form-item>
        <el-form-item label="确认新密码" required>
          <el-input v-model="pwdForm.confirmPassword" type="password" show-password />
        </el-form-item>
        <el-form-item label="二级密码" required>
          <el-input v-model="pwdForm.secondaryPassword" type="password" show-password placeholder="敏感操作二级密码" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="pwdVisible = false">取消</el-button>
        <el-button type="primary" :loading="pwdLoading" @click="submitPassword">确认修改</el-button>
      </template>
    </el-dialog>
  </div>
</template>
  
<script setup>
import { computed, reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { rqLogout, rqModifyUserPassword } from '@/api'

const route = useRoute()
const router = useRouter()
const currentRoute = computed(() => route.path)
const displayName = computed(() => localStorage.getItem('username') || '管理员')

const pwdVisible = ref(false)
const pwdLoading = ref(false)
const pwdForm = reactive({
  oldPassword: '',
  newPassword: '',
  confirmPassword: '',
  secondaryPassword: ''
})

const clearAuth = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('username')
  localStorage.removeItem('userId')
  localStorage.removeItem('mustChangePassword')
}

const logout = async () => {
  try {
    await ElMessageBox.confirm('确认退出登录？', '提示', { type: 'warning' })
  } catch {
    return
  }
  try {
    await rqLogout()
  } catch (_) {
    /* ignore */
  }
  clearAuth()
  router.replace('/login')
}

const submitPassword = async () => {
  if (!pwdForm.oldPassword || !pwdForm.newPassword || !pwdForm.secondaryPassword) {
    ElMessage.warning('请填写完整')
    return
  }
  if (pwdForm.newPassword !== pwdForm.confirmPassword) {
    ElMessage.warning('两次新密码不一致')
    return
  }
  if (pwdForm.newPassword.length < 8) {
    ElMessage.warning('新密码至少 8 位')
    return
  }
  pwdLoading.value = true
  try {
    const res = await rqModifyUserPassword({
      oldPassword: pwdForm.oldPassword,
      newPassword: pwdForm.newPassword,
      secondaryPassword: pwdForm.secondaryPassword
    })
    const body = res?.data ?? res
    if (body?.code && body.code !== 200) {
      ElMessage.error(body.message || '修改失败')
      return
    }
    ElMessage.success('密码已修改，请重新登录')
    pwdVisible.value = false
    clearAuth()
    router.replace('/login')
  } catch (e) {
    ElMessage.error(e?.response?.data?.message || e?.message || '修改失败')
  } finally {
    pwdLoading.value = false
  }
}
</script>
  
  
  <style lang="less" scoped>
.head {
  position: relative;
  background-color: #81888f;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .head-right {
    display: flex;
    align-items: center;
    gap: 12px;
    padding-right: 16px;
  }
  .username {
    color: #fff;
    font-size: 14px;
  }
  img {
    width: 35px;
    height: 35px;
    box-sizing: border-box;
    border-radius: 50%;
    border: 1px solid #aaa;
  }
}
.common-layout{
  overflow: hidden;
}
.common-layout,
.el-container,
.el-menu {
  height: 100%;
}
.el-aside {
  width: 220px !important;
}
</style>
